module.exports = {
    "frames": [
        {
            "time": 0,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-launch-yellow/p-launch-yellow1_.png").default
        },
        {
            "time": 100,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-launch-yellow/p-launch-yellow2_.png").default
        },
        {
            "time": 200,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-launch-yellow/p-launch-yellow3_.png").default
        },
        {
            "time": 300,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-launch-yellow/p-launch-yellow4_.png").default
        },
        {
            "time": 400,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-launch-yellow/p-launch-yellow5_.png").default
        },
        {
            "time": 500,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-launch-yellow/p-launch-yellow6_.png").default
        },
        {
            "time": 600,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-launch-yellow/p-launch-yellow7_.png").default,
            "duration": 50,
        },
        {
            "time": 650,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-launch-yellow/p-launch-yellow8_.png").default
        },
        {
            "time": 750,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-launch-yellow/p-launch-yellow9_.png").default
        },
        {
            "time": 850,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-launch-yellow/p-launch-yellow10_.png").default
        },
        {
            "time": 950,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-launch-yellow/p-launch-yellow11_.png").default
        },
        {
            "time": 1050,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-launch-yellow/p-launch-yellow12_.png").default
        },
        {
            "time": 1150,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-ready-yellow/p-ready-yellow1_.png").default
        }
    ]
}
